import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=2f5c6725&scoped=true&"
import script from "./phoneLogin.vue?vue&type=script&lang=js&"
export * from "./phoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=2f5c6725&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c6725",
  null
  
)

export default component.exports